const currentYear = new Date().getFullYear();

const locale = {
    code: "ko",
    label: "한국어",
    NAV_BAR: {
        home: "홈",
        homeId: "home",
        aboutus: "회사 소개",
        aboutId: "aboutus",
        faq: "FAQ",
        faqId: "faq-section",
        contact: "문의",
        contactId: "contact-section",
        button: "사전 액세스 받기",
    },

    HERO: {
        heroHeading: "메뉴를 즉시 이용할 수 있습니다",
        heroParagraph:
            "하나의 QR 코드로 메뉴를 만들고, 업데이트하고, 공유하세요 — 번거로움 없이, 재인쇄 없이.",
        button: "사전 액세스 받기",
        downloadText: "다운로드하기",
        appStore: "App Store",
        getItOn: "GET IT ON",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "서비스",
        cards: [
            {
                title: "메뉴 만들기 및 업로드",
                description:
                    "몇 번의 클릭만으로 메뉴를 쉽게 만들고 업로드하세요! 항목을 추가하고, 가격을 설정하고, 기술 없이 세부 정보를 업데이트하세요.",
            },
            {
                title: "메뉴 업데이트",
                description:
                    "언제 어디서나 메뉴를 실시간으로 업데이트하세요! 가격을 변경하고, 새 음식을 추가하고, 이용 불가 항목을 즉시 보관하세요.",
            },
            {
                title: "생성 및 공유",
                description:
                    "메뉴에 대해 고유한 QR 코드를 즉시 생성하세요! 테이블, 포스터 또는 온라인에서 공유하여 고객이 스캔하고 최신 메뉴에 액세스할 수 있게 하세요.",
            },
        ],
    },

    FEATURES: {
        heading: "놀라운 기능을 탐색하세요",
        lists: [
            {
                title: "메뉴 관리",
                description:
                    "언제든지 메뉴를 관리하세요! 항목을 쉽게 추가, 편집 또는 삭제하여 제공 내용을 최신 상태로 유지하세요.",
            },
            {
                title: "통찰력 및 보고서",
                description:
                    "실시간 보고서로 가치 있는 인사이트를 얻으세요! 메뉴 조회, QR 코드 스캔 및 고객 상호작용을 추적하세요.",
            },
            {
                title: "QR 코드 공유",
                description:
                    "고유한 QR 코드로 메뉴를 공유하세요! 테이블, 포스터 또는 온라인에서 표시하여 고객이 즉시 스캔할 수 있게 하세요.",
            },
            {
                title: "고객 리뷰",
                description:
                    "실제 고객 피드백과 평가를 보여주세요! 신뢰를 구축하고 메뉴를 개선하며 식사 경험을 향상시키세요.",
            },
            {
                title: "오퍼 및 할인",
                description:
                    "특별 오퍼 및 할인으로 판매를 촉진하세요! 기간 한정 프로모션과 독점 할인을 강조하세요.",
            },
        ],
    },

    ABOUT: {
        heading: "My QR Menu 소개",
        headingPara: "실시간 업데이트로 레스토랑 메뉴 관리를 간소화하세요.",
        highlightHeading: "필요한 모든 항목에 빠르고 쉽게 접근하세요",
        highlightPara: "메뉴의 모든 기능을 한 번의 터치로 이용할 수 있습니다.",
        cards: {
            left: {
                heading: ["재료를 쉽게 추가하세요", "QR 메뉴에"],
                alt: "재료 추가",
            },
            right: {
                heading: ["메뉴", "대시보드에 쉽게 접근"],
                alt: "메뉴 대시보드",
            },
        },
    },

    FAQ: {
        heading: "질문이 있으신가요? 답변이 있습니다.",
        subheading: "제품에 대해 알아야 할 모든 것.",
        items: [
            {
                question: "My QRMenu란 무엇인가요?",
                answer:
                    "My QRMenu는 레스토랑이 QR 코드를 사용하여 메뉴를 즉시 생성, 업데이트 및 공유할 수 있는 디지털 메뉴 플랫폼입니다.",
            },
            {
                question: "생성 후 메뉴를 업데이트할 수 있나요?",
                answer:
                    "네, 언제든지 메뉴를 업데이트할 수 있으며 고객이 QR 코드를 스캔하면 즉시 반영됩니다.",
            },
            {
                question: "My QRMenu는 어떻게 작동하나요?",
                answer:
                    "메뉴를 생성하고, QR 코드를 생성하면 고객이 스캔하여 최신 메뉴를 확인합니다.",
            },
            {
                question: "QR 코드를 어떻게 공유하나요?",
                answer:
                    "QR 코드를 디지털로 공유하거나 매장에서 표시하도록 인쇄할 수 있습니다.",
            },
            {
                question: "My QRMenu는 모바일 친화적인가요?",
                answer:
                    "네, My QRMenu는 스마트폰 및 태블릿을 포함한 모든 디바이스에 최적화되어 있습니다.",
            },
            {
                question: "고객 리뷰를 수집할 수 있나요?",
                answer:
                    "네, 고객 리뷰를 활성화하고 피드백을 사용하여 제안을 개선할 수 있습니다.",
            },
        ],
    },

    CONTACT: {
        heading: "문의하기",
        subheading: "친절한 팀이 여러분의 소식을 기다리고 있습니다.",
        firstName: "이름",
        lastName: "성",
        email: "이메일",
        message: "메시지",
        firstNamePlaceholder: "이름",
        lastNamePlaceholder: "성",
        emailPlaceholder: "you@company.com",
        messagePlaceholder: "메시지를 입력하세요...",
        privacyConsent: "귀하는 당사의",
        privacyPolicy: "개인정보처리방침에 동의합니다",
        submitButton: "메시지 보내기",
        toast: {
            requiredConsent: "개인정보처리방침에 동의해야 합니다.",
            submitting: "메시지 전송 중...",
            success: "메시지가 성공적으로 전송되었습니다!",
            fail: "메시지 전송에 실패했습니다. 다시 시도해주세요.",
            error: "오류가 발생했습니다. 연결을 확인해주세요.",
        },
    },

    HELP_PAGE: {
        title: "도움말 센터",
        description: "질문이 있거나 지원이 필요하시면 다음으로 문의해주세요: ",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "또는 아래 FAQ를 살펴보세요. 찾고 있는 답을 찾을 수 있습니다.",
    },

    FOOTER: {
        footerHeading: "원활한 디지털 메뉴, 단순화되었습니다!",
        footerButton: "대기 명단에 참여",
        footerConnect: "우리와 연결",
        footerTerms: "약관 및 동의",
        footerHelp: "도움말 센터",
        footerPrivacy: "개인정보처리방침",
        footerCopyright: `©${currentYear} 판권 소유.`,
    },

    PRIVACY_POLICY: {
        title: "개인정보 처리방침",
        lastUpdated: "최종 업데이트: 2025年 5月 22日",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                본 개인정보 처리방침은 귀하가 서비스를 이용할 때 귀하의 정보를 수집, 이용 및 공개하는 당사의 정책과 절차를 설명합니다.
                </p>
                <p class="mb-6 leading-relaxed">
                당사는 서비스를 제공하고 개선하기 위해 귀하의 개인 데이터를 사용합니다. 서비스를 이용함으로써 귀하는 본 개인정보 처리방침에 따른 정보 수집 및 이용에 동의하게 됩니다.
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">해석 및 정의</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">해석</h3>
                <p class="mb-6 leading-relaxed">
                    첫 글자가 대문자인 단어는 다음 조건에 따라 정의된 의미를 갖습니다.
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">定義</h3>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>계정</strong> 이란 당사의 서비스에 액세스하기 위해 생성된 고유한 계정을 의미합니다.</li>
                    <li><strong>회사</strong> 는 <strong>My QR Menu,</strong> 영국 런던을 나타냅니다.</li>
                    <li><strong>개인 데이터</strong> 는 식별되거나 식별 가능한 개인과 관련된 모든 정보입니다.</li>
                    <li><strong>귀하</strong> 는 서비스에 액세스하거나 서비스를 이용하는 개인을 의미합니다.</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">문의하기</h2>
                <p>
                본 개인정보 처리방침에 대해 질문이 있는 경우 당사에 문의할 수 있습니다.
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>이메일: <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "이용약관",
        lastUpdated: "최종 업데이트: 2025년 5월 22일",
        content: `
            <p class="leading-relaxed mb-6">
            당사의 앱 또는 웹사이트를 이용하시기 전에 본 이용약관을 주의 깊게 읽어주시기 바랍니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">1. 해석 및 정의</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">해석</h3>
            <p class="leading-relaxed mb-4">
            첫 글자가 대문자인 단어는 다음 조건에 따라 정의된 의미를 갖습니다.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">정의</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>애플리케이션</strong> 이란 My QR Menu가 제공하는 소프트웨어를 의미합니다.</li>
            <li><strong>회사</strong> 는 영국 런던의 My QR Menu를 나타냅니다.</li>
            <li><strong>서비스</strong> 는 애플리케이션 및 웹사이트를 의미합니다.</li>
            <li><strong>귀하</strong> 는 서비스에 액세스하거나 서비스를 이용하는 개인 또는 기업을 의미합니다.</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">2. 승인</h2>
            <p class="leading-relaxed mb-6">
            서비스에 액세스하거나 서비스를 이용함으로써 귀하는 본 약관에 동의하게 됩니다. 본 약관의 일부라도 동의하지 않는 경우 서비스에 액세스할 수 없습니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">3. 타 사이트로의 링크</h2>
            <p class="leading-relaxed mb-6">
            당사의 서비스에는 제3자 웹사이트에 대한 링크가 포함될 수 있습니다. 당사는 해당 사이트의 콘텐츠나 관행에 대해 책임을 지지 않습니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">4. 종료</h2>
            <p class="leading-relaxed mb-6">
            당사는 어떠한 이유로든 사전 통지 없이 즉시 귀하의 서비스 액세스를 종료하거나 중단할 권리를 보유합니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">5. 책임의 제한</h2>
            <p class="leading-relaxed mb-6">
            법률이 허용하는 최대 범위 내에서 회사는 서비스 이용으로 인해 발생하는 어떠한 손해에 대해서도 책임을 지지 않습니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">6. "있는 그대로" 및 "이용 가능한 대로" 면책 조항</h2>
            <p class="leading-relaxed mb-6">
            서비스는 "있는 그대로" 및 "이용 가능한 대로" 귀하에게 제공됩니다. 당사는 서비스가 무오류 또는 중단 없이 제공될 것임을 보장하지 않습니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">7. 준거법</h2>
            <p class="leading-relaxed mb-6">
            본 약관은 영국 법률의 적용을 받습니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">8. 분쟁 해결</h2>
            <p class="leading-relaxed mb-6">
            당사와 분쟁이 발생하는 경우 법적 조치를 취하기 전에 먼저 비공식적으로 해결을 시도하는 데 동의합니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">9. 유럽 연합(EU) 사용자 관련</h2>
            <p class="leading-relaxed mb-6">
            귀하가 EU 소비자라면 거주 국가 법률의 필수 규정에 따른 보호를 받을 권리가 있습니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">10. 미국 법률 준수</h2>
            <p class="leading-relaxed mb-6">
            귀하는 귀하가 미국 정부의 제재 대상 국가에 거주하지 않음을 보장합니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">11. 분리 가능성 및 포기</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">분리 가능성</h3>
            <p class="leading-relaxed mb-4">
            본 약관의 일부 조항이 집행 불가능한 것으로 판명되더라도 나머지 조항은 계속해서 효력을 유지합니다.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">포기</h3>
            <p class="leading-relaxed mb-6">
            권리 행사를 하지 않는다고 해서 해당 권리를 포기하는 것은 아닙니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">12. 번역 해석</h2>
            <p class="leading-relaxed mb-6">
            본 약관은 번역되었을 수 있습니다. 분쟁이 발생하는 경우 영문 본이 우선합니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">13. 본 약관의 변경</h2>
            <p class="leading-relaxed mb-6">
            당사는 언제든지 본 약관을 업데이트할 수 있습니다. 변경 시 웹사이트에 공지사항을 게시하여 알려드립니다.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">14. 문의하기</h2>
            <p class="leading-relaxed mb-2">본 약관에 대해 질문이 있는 경우 당사에 문의할 수 있습니다.</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>이메일 문의: <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
